import {
  FlexContainer,
  FlexColumn,
} from '@editor/components/utilities/layouts';
import { P2, P4 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { Alignment } from './types';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: center;
  padding: ${({ theme }) => theme.padding || '32px 24px'};
  max-width: 100%;
`;

const toFlexAlignment = (alignment?: Alignment): string => {
  switch (alignment) {
    case 'left':
      return 'flex-start';
    case 'right':
      return 'flex-end';
    default:
      return 'center';
  }
};

export const Header = styled(FlexColumn)<{ $contentAlignment?: Alignment }>`
  align-items: ${({ $contentAlignment }) => toFlexAlignment($contentAlignment)};
  text-align: ${({ $contentAlignment }) => $contentAlignment || 'center'};
  gap: 20px;
`;

export const Message = styled(P2)<{ $contentAlignment?: Alignment }>`
  text-align: ${({ $contentAlignment }) => $contentAlignment || 'center'};
  white-space: pre-line;
  margin-top: 12px;
`;

export const Note = styled(P4)<{ $contentAlignment?: Alignment }>`
  text-align: ${({ $contentAlignment }) => $contentAlignment || 'center'};
  color: ${themeStyle.varInkMedium};
  white-space: pre-line;
  margin-top: 6px;
`;

export const TextInputWrapper = styled.div`
  margin-top: 24px;
`;

export const ButtonWrapper = styled(FlexContainer)<{
  $buttonsAlignment?: Alignment;
}>`
  justify-content: ${({ $buttonsAlignment }) =>
    toFlexAlignment($buttonsAlignment)};
  gap: 12px;
  margin-top: 24px;
`;
